import placesListModule from '../placesListModule';

function gameTileController($scope, $log, resources, $filter, $uibModal, $window, playGameService) {
  'ngInject';

  let isClickFromAvatar = false;
  $scope.goToGameDetails = function() {
    if (isClickFromAvatar) {
      isClickFromAvatar = false;
      return false;
    }
    const sortInfo = $scope.library.knowledgeOfSorts[$scope.name];
    if (sortInfo.isInstantPlayEnabled) {
      const rootPlaceId = $scope.game.placeId;
      const { placeId } = $scope.game;
      const propertiesForEvent = {
        rootPlaceId,
        placeId
      };
      const playGameProperties = playGameService.buildPlayGameProperties(
        rootPlaceId,
        placeId,
        null,
        null
      );
      const eventStreamProperties = {
        eventName: resources.eventStreamParams.joinGameInPlacesList.name,
        ctx: resources.eventStreamParams.joinGameInPlacesList.ctx,
        properties: propertiesForEvent,
        gamePlayIntentEventCtx: resources.eventStreamParams.gamePlayIntentInPlacesList.ctx
      };
      playGameService.launchGame(playGameProperties, eventStreamProperties);
    } else {
      const localTimestamp = new Date().toISOString();
      let { gameReferralUrl } = $scope.game;
      gameReferralUrl = $filter('formatString')(gameReferralUrl, {
        localTimestamp
      });
      $scope.game.gameReferralUrl = gameReferralUrl;
      $window.location.href = gameReferralUrl;
    }
  };

  $scope.startPlayerInteration = function() {
    $scope.library.modalStatus[$scope.game.universeId] = {
      isOpen: true
    };
    const sortInfo = $scope.library.knowledgeOfSorts[$scope.name];
    const modalInstance = $uibModal.open({
      templateUrl: resources.modals.playerInteraction.templateName,
      controller: resources.modals.playerInteraction.controllerName,
      resolve: {
        modalData: {
          game: $scope.game,
          library: $scope.library,
          layout: $scope.layout,
          sortInfo
        }
      }
    });

    modalInstance.result.then(
      function close() {},
      function dismiss() {
        if ($scope.library.tempPeopleInGameLibrary) {
          angular.forEach($scope.library.tempPeopleInGameLibrary, function(
            peopleInGame,
            rootPlaceId
          ) {
            $scope.library.peopleInGameLibrary[rootPlaceId] = peopleInGame;
          });
          $scope.library.tempPeopleInGameLibrary = {};
        }
        $scope.library.modalStatus[$scope.game.universeId].isOpen = false;
      }
    );
    isClickFromAvatar = true;
  };

  $scope.isAnyPlayerInGame = function() {
    return $scope.library.peopleInGameLibrary &&
      $scope.library.peopleInGameLibrary[$scope.game.placeId]
      ? $scope.library.peopleInGameLibrary[$scope.game.placeId].length > 0
      : false;
  };
}

placesListModule.controller('gameTileController', gameTileController);

export default gameTileController;
